import * as React from 'react';
import { SlideUpPanel } from 'mobile-ui/components/slideup-panel';
import {
    actions as overlayWindowsActions,
    FavoritesExportLayerChooserOperation
} from 'services/overlay-windows/overlay-windows-service';
import { PanelBody, PanelHeader, CloseButton } from 'components';
import { FavoritesExportLayerList } from 'scenes/overlay-favorites-layer-chooser/layers-list';
import { useSelector } from 'react-redux';
import { IState } from 'services/root-reducer';
import { getOperationSafe } from 'selectors';
import { useTranslation } from 'react-i18next';

export const MobileUIFavoritesExportLayerChooser = () => {
    let favoritesLayerExportOperation = useSelector(
        (state: IState) => getOperationSafe(state, 'EXPORT_OBJECTS_LAYER_CHOOSER_OVERLAY')
    );
    const { t } = useTranslation();

    if (
        !favoritesLayerExportOperation.data?.visible
        || !favoritesLayerExportOperation.data?.objects
    ) {
        return null;
    }

    return (
        <SlideUpPanel
            open
            className='mobile-ui-favorites-export-layer-chooser fix-close-button'
        >
            <PanelHeader>
                <div className="header-text">
                    {t('Выберите слой для выгрузки')}
                </div>
                <CloseButton
                    onClick={() => {
                        overlayWindowsActions.hideExportLayerChooserOverlay();
                    }}
                />
            </PanelHeader>

            <PanelBody>
                <FavoritesExportLayerList
                    iconExportButton
                />
            </PanelBody>
        </SlideUpPanel>
    );
};
